import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ContainerButton = styled.div<{
	justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between';
}>`
	display: flex;
	width: 100%;
	margin: 0;
	padding-top: 64px;
	gap: 26px;
	justify-content: ${({ justify }) => justify ?? 'space-between'};
	align-items: center;

	p {
		font-family: ${tokens.font_family_primary};
		font-size: 18px;
		font-weight: 400;
		color: ${tokens.color_gray_dark};
	}
`;
